import { gql } from "@apollo/client";

import { TRANSACTION_INFO } from "../fragments";

export const RECHARGE_REQUEST = gql`
  mutation rechargeRequest($amount: Int!) {
    rechargeRequest(amount: $amount) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const WITHDRAW_REQUEST = gql`
  mutation withdrawRequest($amount: Int!, $password: String) {
    withdrawRequest(amount: $amount, password: $password) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const DEPOSIT = gql`
  mutation deposit($input: DepositInput!) {
    deposit(input: $input) {
      id
      profit
      amount
    }
  }
`;
